import { Box, Tooltip, Typography } from '@mui/material';
import { MinutesRange } from './valueKinds';

export interface TimelineSegmentGroup {
  label: string;
  ranges: MinutesRange[];
  color: string;
}

const MINUTES_IN_DAY = 1440;
const HOUR_TICKS = [0, 3, 6, 9, 12, 15, 18, 21, 24];

const pct = (minutes: number) => `${(minutes / MINUTES_IN_DAY) * 100}%`;
const hhmm = (minutes: number) => `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

/** One 24h row per segment group; ranges are minutes from midnight, drawn as absolutely positioned bars. */
export const Timeline = ({ segments }: { segments: TimelineSegmentGroup[] }) => (
  <Box data-testid="timeline" sx={{ display: 'grid', gridTemplateColumns: '120px 1fr', rowGap: 0.5, columnGap: 1, alignItems: 'center' }}>
    <Box />
    <Box sx={{ position: 'relative', height: 14 }}>
      {HOUR_TICKS.map((h) => (
        <Typography key={h} variant="caption" sx={{ position: 'absolute', left: pct(h * 60), transform: 'translateX(-50%)', color: 'text.secondary' }}>
          {h}
        </Typography>
      ))}
    </Box>
    {segments.map((s) => (
      <Box key={s.label} sx={{ display: 'contents' }}>
        <Typography variant="caption" noWrap title={s.label}>
          {s.label}
        </Typography>
        <Box sx={{ position: 'relative', height: 18, bgcolor: 'action.hover', borderRadius: 1 }}>
          {s.ranges.map((r, i) => (
            <Tooltip key={i} title={`${s.label} ${hhmm(r.start)}–${hhmm(r.end)}`}>
              <Box data-testid="timeline-segment" sx={{ position: 'absolute', left: pct(r.start), width: pct(Math.max(r.end - r.start, 2)), top: 2, bottom: 2, bgcolor: s.color, borderRadius: 0.5 }} />
            </Tooltip>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);
